{
  "labels": {
    "ime": "First Name:",
    "priimek": "Last Name:",
    "naslov": "Address:",
    "posta": "Postal Code:",
    "kraj": "City:",
    "email": "Email:",
    "telefon": "Phone:",
    "klub": "Select club:",
    "naletJ": "Glider hours:",
    "naletM": "Motor hours:",
    "licenca": "License number",
    "instruktor": "Instructor (motor)",
    "instruktorJ":"Instructor (glider)",
    "instruktorUL": "Instructor (ultralight)",
    "vlecniR": "Tow rating",
    "opomba": "Note",
    "jadralniP": "Pilot (glider)",
    "motorniP": "Pilot (motor)",
    "ultraP": "Pilot (ultralight)"
  },
  "buttons": {
    "vnos": "Add entry",
    "brisiIzbiro": "Clear selection"
  }
}